module.exports = __webpack_public_path__ + "static/img/5.57c634a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/2/sp/5.png
// module id = +Ddw
// module chunks = 0